module.exports = __webpack_public_path__ + "static/media/nav_left_stats.f3cc55d6.svg";